/**
 * Sorts an array of pricing ranges by their minimum employee threshold (from)
 *
 * @param prices - Array of pricing ranges to sort
 * @returns A new array sorted in ascending order by the 'from' field
 *
 * The function is used to ensure pricing ranges are in order from lowest to highest
 * employee threshold, which is essential for:
 * - Finding the correct price range for a given number of employees
 * - Displaying pricing tiers in a logical order
 *
 * @example
 * ```ts
 * const prices = [
 *   { from: 50, price: 30 },
 *   { from: 0, price: 50 },
 *   { from: 10, price: 40 }
 * ];
 *
 * orderPricingRange(prices);
 * // Returns: [
 * //   { from: 0, price: 50 },
 * //   { from: 10, price: 40 },
 * //   { from: 50, price: 30 }
 * // ]
 * ```
 */

export const orderPricingRange = <T extends { from: number }>(
  pricingRange: T[],
): T[] => {
  return [...pricingRange].sort((a, b) => a.from - b.from);
};
